"use strict";
/**
 * Created by Ning Jiang on 12/9/2016.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.WinRatioType = void 0;
var WinRatioType;
(function (WinRatioType) {
    WinRatioType["TINY"] = "tiny";
    WinRatioType["SMALL"] = "small";
    WinRatioType["MEDIUM"] = "medium";
    WinRatioType["LARGE"] = "large";
    WinRatioType["BIG_WIN"] = "bigWin";
    WinRatioType["MEGA_WIN"] = "megaWin";
    WinRatioType["SUPER_MEGA_WIN"] = "superMegaWin";
})(WinRatioType = exports.WinRatioType || (exports.WinRatioType = {}));
//# sourceMappingURL=WinRatio.js.map